import { segmentFilterOptions } from 'constants/filters';

export const CONTACT_FILTER_OPTIONS = [
  { value: { type: 'FIRSTNAME' }, label: 'First name', data_type: 'string', config: { multiple: false } },
  { value: { type: 'LASTNAME' }, label: 'Last name', data_type: 'string', config: { multiple: false } },
  { value: { type: 'EMAIL' }, label: 'Email', data_type: 'string', config: { multiple: false } },
  { value: { type: 'COMPANY' }, label: 'Company', data_type: 'string', config: { multiple: false } },
  { value: { type: 'TITLE' }, label: 'Title', data_type: 'string', config: { multiple: false } },
];

export const CONTENT_GRID_PERSONALIZATION_FILTER_OPTIONS = [
  ...segmentFilterOptions.filter((opt) => opt.value.type !== 'ALIAS'),
  ...CONTACT_FILTER_OPTIONS,
];
